// The store locator bar is now rendered inside SiteHeader as .kh-secondary.
// This component is kept as a no-op to avoid import errors.
export function StoreLocatorBar() {
  return null;
}
